// extracted by mini-css-extract-plugin
export default {"subtitle":"C5egV4","noBottomMargin":"xqYuHc"};